/**
 * @desc 获取会议 Reaction 状态
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 会议房间 ID */
  channelId?: number;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey('/api/bs-vmeeting/v3/meeting/reaction', params, 'GET'),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/reaction',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl('/api/bs-vmeeting/v3/meeting/reaction', params, 'GET'),
    {
      method: 'GET',

      ...options,
    },
  );
}
